let mainNavLinks = document.querySelectorAll( '[data-solutions-links] a' );
let mainSections = document.querySelectorAll( 'li.solution' );

let lastId;
let cur = [];

const checkNavLocation = () => {
	let fromTop = window.scrollY;

	mainNavLinks.forEach( link => {

		let section = document.querySelector( link.hash );

		if (
			section.offsetTop <= fromTop + 100 &&
			section.offsetTop + section.offsetHeight > fromTop + 100
		) {
			// console.log( section );
			link.classList.add( 'current' );
		} else {
			link.classList.remove( 'current' );
		}

	});
}

window.addEventListener( 'scroll', checkNavLocation );
document.addEventListener( 'DOMContentLoaded', checkNavLocation );
